<template>
    <va-create-layout>
        <ShipmentEventShipmentItemFee-form
            :title="title"
            :item="item"
        ></ShipmentEventShipmentItemFee-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
